import { httpV1 as http } from '../api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult({ isFGTS = false, ...params }) {
  return isFGTS
    ? http.get('/celcoin/fgts/balance', { params })
    : http.get('/private-payroll/celcoin/balance', { params });
}

export async function simulate(data) {
  return http.post('/private-payroll/celcoin/simulation', data);
}

export async function creditOperation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/ccb-issuance`, data);
}

export async function proposal(params) {
  return http.get('/private-payroll/celcoin/proposal', { params });
}

export async function cancelReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/cancel`, data);
}

export async function riskAnalysis(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/risk-analysis`, data);
}

export async function employeeRelationship(params) {
  return http.get('/private-payroll/celcoin/employment-relationships-inquiry', { params });
}

/* FGTS */
export async function tryAgain(data) {
  return http.put(`${ALT_API_URL}/celcoin/fgts/credit-operation`, data);
}

export async function verify(params) {
  return http.get('/celcoin/fgts/proposal', { params });
}

export async function cancel(id) {
  return http.delete(`/celcoin/fgts/proposal/${id}`);
}

export async function withdrawalProposal(externalProposalId) {
  return http.post('/celcoin/fgts/proposal/reversal', {
    external_proposal_id: externalProposalId,
  });
}
